document.addEventListener('DOMContentLoaded', function () {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('panda-reveal--visible');
      });
    },
    { threshold: 0.08 }
  );
  function observeAll(root) {
    root.querySelectorAll('.panda-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  observeAll(document);
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
});
